module.exports = __webpack_public_path__ + "media/images/bg02-44d3abb15e06b05e95032ad38c55b04f.png";